import { tick } from "svelte";
import type { ScrollHistoryMode } from "./router";

export const scrollHistory = new Map<string, { top: number; left: number }>();
history.scrollRestoration = "manual";

export class ScrollHistory implements ScrollHistoryMode {
  private history = new Map<string, { top: number; left: number }>();

  store(path: string) {
    this.history.set(path, { top: window.scrollY, left: window.scrollY });
  }

  async apply(path: string, restore: boolean, behavior?: ScrollBehavior) {
    await tick();
    let pos = restore ? this.history.get(path) : { top: 0, left: 0 };
    window.scrollTo({ ...pos, behavior });
  }
}
